import {PageWithoutFooter} from "../Page";
import {useSearchParams} from "react-router-dom";
import {Button, Text} from "@wakelet/ui-kit";
import {useEffect, useState} from "react";
import {AccountsAPI, OAuthRequestParams} from "../../accounts-api/accounts-api";
import {OAuthStore} from "../../components/auth/store";
import {useNavigate} from "react-router";

const getDevSuffix = (isDev: boolean): string => isDev ? "?dev=true" : "";

export const OAuthInitPage = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const isDev = params.get("dev") === "true";
  const [submitAuth, setSubmitAuth] = useState<boolean>(!isDev);

  OAuthStore.clear();
  const req = toRequest(params);

  useEffect(() => {
    if (submitAuth) {
      AccountsAPI.initiateAuthentication(req)
      .then(res => {
        OAuthStore.setSession(res.sessionId);
        OAuthStore.setRedirectUri(res.location);
        let navTo = "/oauth/start"
        if (req.provider && req.provider_code) {
          const postAuthURL = new URLSearchParams();
          postAuthURL.set("code", req.provider_code);
          postAuthURL.set("scope", req.provider_scope || "");
          navTo = `/login/${req.provider}/post-auth?${postAuthURL.toString()}`;
        }
        navigate(navTo + getDevSuffix(isDev))
      })
      .catch(err => {
        console.error(err);
        navigate("/error");
      });
    }
  }, [submitAuth]);

  if (!isDev) {
    return null;
  }

  const reqDetails: JSX.Element[] = Object.entries(req).map(([key, value]) => {
    return <p key={key}>{key}: {value}</p>
  });

  return <PageWithoutFooter>
    <Text.Heading level={1}>OAuth Init Page</Text.Heading>
    <hr/>
    <div className="mt-5">{reqDetails}</div>
    <Button block onClick={() => setSubmitAuth(true)}>
      <Button.Label text="Init Authentication"/>
    </Button>
  </PageWithoutFooter>;
};

const toRequest = (params: URLSearchParams): OAuthRequestParams => {
  const req: { [key: string]: string } = {};
  const entryIterator = params.entries()
  let result = entryIterator.next();
  while (!result.done) {
    req[result.value[0]] = result.value[1];
    result = entryIterator.next();
  }
  return req as OAuthRequestParams;
};
